import styled from "styled-components";
import VehicleLookupModal from "./VehicleLookupModal";
// import fonts from "../../../views/theme/base/fonts";

const StyledVehicleLookupModal = styled(VehicleLookupModal)`

`;

export default StyledVehicleLookupModal;
